<template>
  <div
    v-loading="loading"
    :class="b()"
  >
    <div :class="b('content')">
      <template v-for="option of options">
        <div
          v-if="option.list.length"
          :key="option.id"
          :class="b('item')"
        >
          <div :class="b('item-title')">
            {{ option.title }}
          </div>
          <div :class="b('item-content', { [option.type]: true })">
            <template v-if="option.type === 'card'">
              <div
                v-for="item of option.list"
                :key="item.id"
                :class="b('card-warp')"
              >
                <ImageCard
                  v-ripple
                  :class="b('card', {[item.code]: true})"
                  :url="item.url"
                  :title="item.title"
                  :description="item.description"
                  @click.native="handleItemClick(item, option.id)"
                />
              </div>
            </template>
            <template v-if="option.type === 'label'">
              <div
                v-for="item of option.list"
                :key="item.id"
                v-ripple
                :class="b('label-item')"
                @click="handleItemClick(item, option.id)"
              >
                <ImageOrIcon
                  v-if="item.icon"
                  :class="b('label-icon')"
                  :src="item.icon"
                  :size="16"
                  symbol
                />{{ item.title }}
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>
    <el-button
      :loading="submitLoadingEvent.loading"
      round
      size="large"
      type="primary"
      :class="b('next-btn')"
      @click="submitLoadingEvent.fn"
    >
      <span v-if="from==='guide'">{{ $t('overseas.guide.feature.footerBtn1') }}</span>
      <span v-else>{{ $t('overseas.guide.feature.footerBtn2') }}</span>
    </el-button>
  </div>
</template>

<script>
import { computed, defineComponent, onMounted, reactive, ref } from 'vue-demi';
//@ts-ignore
import theme from '@zk/theme/lib/variables.scss';
import ImageCard from './image-card/index.vue';
import { createLoadingEvent } from '@zk/framework-vue';
import { guideRecord } from '@/api/overseasGuide';
import { useInstance } from 'common-module/src/util/useInstance';
import { addUrlParams, resolveUrl } from '@zk/framework-vue';
import config from 'common-module/src/config';
import { useI18n } from 'common-module/src/util/useI18n';
import * as permission from 'common-module/src/config/permission';

const URL_MAP = {
  'intel': require('@/assets/welcome/feature-guide/ai.png'),
  'roadMap':require('@/assets/welcome/feature-guide/roadmap.png'),
  'team':require('@/assets/welcome/feature-guide/team.png'),
  'IM_integration':require('@/assets/welcome/feature-guide/im.png'),
  'Dashboard':require('@/assets/welcome/feature-guide/dashboard.png'),
  'IDE':require('@/assets/welcome/feature-guide/plugin.png'),
  'ScreenRecording':require('@/assets/welcome/feature-guide/recorder.png'),
  'SummarizeComments':require('@/assets/welcome/feature-guide/comment-summary.png'),
  'WebIM':require('@/assets/welcome/feature-guide/web-im.png'),
  'GenerateSubtask':require('@/assets/welcome/feature-guide/generate-subtask.png')
};

const PLUGIN_MAP = {
  GitHub: {
    url: '/tools/develop/github-integration',
    permission: permission.integrationGitHub,
    page: '/setting/integration/github'
  },
  GitLab: {
    url: '/tools/develop/gitlab-integration',
    permission: permission.integrationGitLab,
    page: '/setting/integration/gitLab'
  },
  Jenkins: {
    url: '/tools/develop/jenkins',
    permission: permission.integrationJenkins,
    page: '/setting/integration/jenkins'
  },
  Slack: {
    url: '/tools/communicate/slack-integration',
    permission: permission.integrationSlack,
    page: '/setting/integration/slack'
  },
  Figma: {
    url: '/tools/apps/figma-integration',
    permission: permission.integrationFigma,
    page: '/setting/integration/figma'
  },
  Jira: {
    url: '/tools/apps/import-work-from-jira',
    permission: permission.systemImport,
    page: '/setting/import/jira'
  }
};

const IDE_STORE_URL_MAP = {
  JetBrains: 'https://plugins.jetbrains.com/plugin/20428-leiga',
  VSCode: 'https://marketplace.visualstudio.com/items?itemName=leiga.leiga&ssr=false#overview',
  Eclipse: ''
};

const FEATURE_GUIDE_RECORD = 21;
const loading = ref(false);

export default defineComponent({
  name: 'FeatureGuide',
  bemNS: theme.bemNS,
  components: {
    ImageCard
  },
  props: {
    from: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {

    const instance = useInstance();
    const clickItem = {
      recommend: [],
      plugin: [],
      other: []
    };
    const { t } = useI18n();
    const recommendCardItem = reactive({
      id: 'recommend',
      type: 'card',
      list: [],
      title: ''
    });

    const pluginItem = reactive({
      id: 'plugin',
      type: 'label',
      list: [],
      title: t('overseas.guide.feature.title2')
    });

    const otherCardItem = reactive({
      id: 'other',
      type: 'card',
      list: [],
      title: t('overseas.guide.feature.title3')
    });

    const getGuideInfo = async ()=> {
      await instance.$store.dispatch('overseasGuide/getGuideInfo');
    };

    const init = async () => {
      loading.value = true;
      try {
        await getGuideInfo();
      } finally {
        loading.value = false;
      }
    };

    const recommendTitle = computed(
      () => {
        const { roleVoList } = instance.$store.state.overseasGuide.guideRecommendData;
        if (roleVoList?.length === 1){
          return t('overseas.guide.feature.nameTitle1', { name: roleVoList[0].preferencesName + 's' });

        }
        return t('overseas.guide.feature.title1');
      }
    );

    const options = computed(
      () => {
        const { recommendList, pluginVoList, otherList } = instance.$store.state.overseasGuide.guideRecommendData;
        recommendCardItem.title = recommendTitle.value;
        recommendCardItem.list = recommendList?.map(
          (item) => {
            return {
              id: item.id,
              title: item.head,
              description: item.description,
              documentUrl: item.documentUrl,
              url: URL_MAP[item.code],
              code: item.code
            };
          }
        ) || [];
        pluginItem.list = pluginVoList?.map(
          (item) => {
            return {
              id: item.id,
              title: item.preferencesName,
              icon: item.icon,
              code: item.code
            };
          }
        ) || [];
        otherCardItem.list = otherList?.map(
          (item) => {
            return {
              id: item.id,
              title: item.head,
              description: item.description,
              documentUrl: item.documentUrl,
              url: URL_MAP[item.code],
              code: item.code
            };
          }
        ) || [];
        return [
          recommendCardItem,
          pluginItem,
          otherCardItem
        ];
      }
    );

    const handleSubmit = async () => {
      if (props.from === 'guide'){
        await guideRecord(FEATURE_GUIDE_RECORD);
        await instance.$store.dispatch('overseasGuide/getFirstGuideStep');
        await instance.$store.dispatch('app/loadProjects', true);
        instance.$store.commit('overseasGuide/SET_DEFAULT_SHOW_GUIDE_TASK', true);
        instance.$track.send('Guide_Features', {
          plugins: clickItem.plugin?.length > 0 ? clickItem.plugin?.join() : 'empty',
          recommend_features: clickItem.recommend?.length > 0 ? clickItem.recommend?.join() : 'empty',
          more_features: clickItem.other?.length > 0 ? clickItem.other?.join() : 'empty'
        }, true);
        emit('finish', 'feature');
      }
      emit('close');
    };

    const submitLoadingEvent = ref(createLoadingEvent(handleSubmit));

    const openDoc = (path) => {
      let url = resolveUrl(`${config.VUE_APP_DOC_URL}/${path}`);
      //@ts-ignore
      url = `${addUrlParams(url, { t: window?.buildTimestamp })}`;
      window.open(url);
    };

    const trackItemClick = (item, id) => {
      instance.$track.send('Product_Tour_Features', {
        recommend_features: id === 'recommend' ? item.title : 'empty',
        plugins: id === 'plugin' ? item.title : 'empty',
        more_features: id === 'other' ? item.title : 'empty'
      }, true);
    };

    const handleItemClick = async (item, id) => {
      // 记录点击的模块;
      if (!clickItem[id]) {
        clickItem.id = [];
      }
      if (!clickItem[id].includes(item.title)){
        clickItem[id].push(item.title);
      }
      if (props.from !== 'guide') {
        trackItemClick(item, id);
      }

      const { documentUrl, code } = item;
      if (documentUrl){
        openDoc(documentUrl);
        return;
      }
      if (IDE_STORE_URL_MAP[code]){
        window.open(IDE_STORE_URL_MAP[code]);
        return;
      }
      const { url, permission, page } = PLUGIN_MAP[code];
      if (props.from !== 'guide' && checkPermission(permission) && page){
        window.open(resolveUrl(`${config.VUE_APP_PMS_URL}${page}`));
      } else {
        openDoc(url);
      }
    };

    const checkPermission = (permission) =>{
      return instance.$store.getters['user/checkAccessPermission'](permission);
    };

    onMounted(
      async () => {
        await init();
        // 埋点
        if (props.from === 'guide') {
          const recommendFeatures = options.value?.[0].list.map((item) => item.title).join();
          const moreFeatures = options.value?.[2].list.map((item) => item.title).join();
          instance.$track.send('Guide_RecommendFeatures', {
            recommend_features: recommendFeatures,
            more_features: moreFeatures
          }, true);
        }
      }
    );

    return {
      options,
      submitLoadingEvent,
      loading,
      recommendTitle,
      handleItemClick
    };

  }
});
</script>

<style scoped lang="scss">

@include b(feature-guide){
  position: relative;
  display: flex;
  flex-direction: column;
  width: 1080px;
  min-height: 500px;
  max-height: 90%;
  max-width: 90%;
  background: #fff;
  border-radius: 16px;
  box-shadow: var(--shadow-dialog);
  padding: 36px 0;
  @include e(content){
    padding: 0 60px;
    flex: 1;
    overflow: auto;
  }
  @include e(item){
    &:last-child{
      @include e(item-content){
        margin-bottom: 0;
      }
    }
  }
  @include e(item-title){
    font-size: 24px;
    font-weight: var(--weight-font-Semiblod);
    line-height: 32px;
    margin-bottom: 24px;
  }
  @include e(item-content){
    margin-bottom: 40px;
    @include m(card){
      display: flex;
      flex-wrap: wrap;
      min-height: 120px;
      margin-bottom: 28px;
      >div{
        width: 50%;
        padding-bottom: 12px;
        &:nth-of-type(odd){
          padding-right: 12px;
        }
        &:nth-of-type(even){
          padding-left: 12px;
        }
      }
    }
    @include m(label){
      display: flex;
      flex-wrap: wrap;
      margin-top: -12px;
      >div{
        margin-right: 12px;
        margin-top: 12px;
      }
    }
  }
  @include e(label-item){
    display: flex;
    align-items: center;
    border-radius: var(--radius-default);
    border: 1px solid #eaeaea;
    padding: 0 12px;
    height: 50px;
    min-width: 88px;
    cursor: pointer;
    &:hover{
      background-color: var(--brand-color-1);
      border: var(--divider-height) solid var(--gray-5);
    }
    ::v-deep{
      .zk-image-or-icon{
        margin-right: 8px;
        font-size: 32px !important;
      }
    }
  }
 @include e(footer){
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
  }
  @include e(next-btn){
    min-width: 100px;
    position: absolute !important;
    bottom: 32px;
    left: 50%;
    transform: translateX(-50%);
    box-shadow: 0px 6px 12px 0px rgba(96, 97, 132, 0.16);
  }
  @include e(card){
    overflow: hidden;
    height: 100%;
    ::v-deep{
      .zk-image-card__img-box{
        background-color: rgba(245, 245, 245, 1);
      }
    }

    @include m(intel team roadMap GenerateSubtask WebIM){
      ::v-deep {
        .zk-image-card__img-box{
          background-color: #fff;
        }
      }
    }
  }
}
</style>
